import { Button, makeStyles } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import RetryIcon from "@saleor/icons/RetryIcon";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  () => ({
    button: {
      width: "200px",
      padding: "8px 0"
    }
  }),
  { name: "RetryButton" }
);

const RetryButton = ({ ...rest }) => {
  const classes = useStyles();
  return (
    <Button
      variant="outlined"
      color="secondary"
      className={classes.button}
      {...rest}
    >
      <MyTypography variant="body1">
        <RetryIcon color="#009FB8" />
        <FormattedMessage defaultMessage="Retry" />
      </MyTypography>
    </Button>
  );
};

export default RetryButton;
